
export const rules = [
  [
    {
      required: true,
      message: "请输入您的姓名",
    },

  ],
  [
    {
      required: true,
      message: "请输入您的电话",
    },
  ],
  [
    {
      required: true,
      message: "请输入您的邮箱",
    },
    {
      type: "email",
      message: "请输入正确的邮箱",
    }
  ],
  [
    {
      required:true,
      message:"请输入您的问题或意见"
    }
  ],
  
];
